<template>
    <b-modal
        size="md"
        v-model="modalShow"
        title="ヘルスアンサー回答履歴をダウンロード"
        hide-footer
        @ok="handleOk"
        @cancel="close"
        @hidden="close">
        <div class="row">
            <div class="col-12">
                <div class="form-group m-form__group healthSurveyDownloadWrapper">
                    <div class="d-flex align-items-center justify-content-center">
                        <div class="surveyTermLabel">期間</div>
                        <input
                            v-model="surveyStartDate"
                            id="survey_start_date"
                            class="form-control m-input inputHealthSurvey"
                            :class="{ 'is-invalid' : errors.survey_start_date }"
                            type="date">
                        <div class="surveyTermText">〜</div>
                        <input
                            v-model="surveyFinishDate"
                            id="survey_finish_date"
                            class="form-control m-input inputHealthSurvey"
                            :class="{ 'is-invalid' : errors.survey_finish_date }"
                            type="date">
                    </div>
                    <div
                        v-if="errors.survey_start_date"
                        class="invalid-feedback d-block mt-1">
                        {{ errors.survey_start_date[0] }}
                    </div>
                    <div
                        v-if="errors.survey_finish_date"
                        class="invalid-feedback d-block mt-1">
                        {{ errors.survey_finish_date[0] }}
                    </div>
                </div>
            </div>
        </div>
        <div class="d-flex justify-content-center align-items-center">
            <button
                class="btn btn-yokumiru-gray ml-2 mr-2 mb-2"
                :disabled="inProgress"
                @click="close">
                キャンセル
            </button>
            <button
                class="btn btn-yokumiru-orange ml-2 mr-2 mb-2"
                :disabled="inProgress || !isValid"
                @click="handleOk">
                ダウンロード
            </button>
        </div>
    </b-modal>
</template>

<script>
import constants from '../../../../constants'
import YokumiruHelper from '../../../../YokumiruHelper'

export default {
    props: {
        group: {
            type: Object,
            required: true,
        },
    },

    data: function () {
        return {
            helper: YokumiruHelper,
            inProgress: false,
            modalShow: false,
            surveyStartDate: null,
            surveyFinishDate: null,
            errors: {},
        }
    },

    computed: {
        isValid: function () {
            if (this.surveyStartDate === null) return false
            if (this.surveyFinishDate === null) return false

            return this.surveyStartDate <= this.surveyFinishDate
        },
    },

    created: function () {
        bus.$on('open-modal-authorizer-health-survey-download', this.open)
    },

    beforeDestroy: function () {
        bus.$off('open-modal-authorizer-health-survey-download')
    },

    methods: {
        /**
         * モーダル表示
         */
        open: function () {
            this.modalShow = true
        },

        /**
         * モーダルを閉じる
         */
        close: function () {
            this.modalShow = false
            this.errors = {}
        },

        /**
         * ダウンロードボタン押下時
         * @param {object} e
         */
        handleOk: function (e) {
            e.preventDefault()
            this.onSubmit()
        },

        /**
         * ダウンロード
         */
        onSubmit: async function () {
            if (this.inProgress) return
            this.inProgress = true

            const query = `?survey_start_date=${this.surveyStartDate}&survey_finish_date=${this.surveyFinishDate}`

            const endpoint = `${constants.user.groups.endpoint.base}/${this.group.id}/health_surveys/export${query}`
            const options = { responseType : 'blob' }

            await axios.get(endpoint, options)
                .then((response) => {
                    this.errors = {}
                    const blob = new Blob([response.data], {
                        type: response.data.type,
                    })
                    saveAs(blob, `メンタルチェック回答一覧_${this.surveyStartDate.replaceAll('-', '')}-${this.surveyFinishDate.replaceAll('-', '')}.csv`)
                })
                .catch(() => {
                    bus.$emit('alert-danger', 'システムエラーが発生しました。')
                })

            this.inProgress = false
        },
    },
}
</script>

<style scoped lang="scss">
.healthSurveyDownloadWrapper {
    margin: 15px 0 50px;
}

.surveyTermLabel {
    width: 46px;
}

.surveyTermText {
    margin: 0 10px;
}

.inputHealthSurvey {
    width: 160px;
}
</style>
